import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../../../node_modules/@flixbus/honeycomb/dist/scss/components/calendar.scss.js';
import HoneyBem from '../../../../packages/honey-bem/honey-bem.js';
import '@flixbus/honeycomb-icons-react';
import '../../../../packages/props-utils/prop-types.js';

const bem = new HoneyBem('calendar', styles);
function CalendarHeading(_ref) {
  let {
    days
  } = _ref;
  return /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, days.map(_ref2 => {
    let {
      short,
      long
    } = _ref2;
    return /*#__PURE__*/React.createElement("th", {
      role: "columnheader",
      key: short,
      className: bem.e('cell'),
      "aria-label": long
    }, short);
  })));
}
CalendarHeading.propTypes = {
  days: PropTypes.arrayOf(PropTypes.shape({
    short: PropTypes.string.isRequired,
    long: PropTypes.string.isRequired
  })).isRequired
};

export { CalendarHeading };
